import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnnounceSortChangeDirective } from './announce-sort-change.directive';

@NgModule({
	declarations: [AnnounceSortChangeDirective],
	exports: [AnnounceSortChangeDirective],
	imports: [CommonModule],
})
export class AnnounceSortChangeModule {}